import { reactive, readonly } from 'vue';
import { authApi } from '@/services/resources';
import { tokens } from '@/services/api-client';
const state = reactive({ user: null, loading: false, bootstrapped: false });
const permissions = () => state.user?.role?.permissions?.map((p) => p.name) || [];
export const authStore = {
  state: readonly(state),
  get authenticated() { return Boolean(tokens.access() && state.user); },
  get permissionNames() { return permissions(); },
  hasPermission(permission) { return !permission || permissions().includes(permission); },
  async login(credentials) { state.loading = true; try { tokens.set(await authApi.login(credentials)); state.user = await authApi.me(); return state.user; } finally { state.loading = false; } },
  logout() { tokens.clear(); state.user = null; },
  async bootstrap() { if (state.bootstrapped) return; state.loading = true; try { if (tokens.access()) state.user = await authApi.me(); } catch (_) { tokens.clear(); } finally { state.loading = false; state.bootstrapped = true; } },
};
